<template>
<div class="columns">
  <div class="column is-12">
    <div class="hr-tile">
        <ul class="breadcrumbs">
            <li class="breadcrumb-item">
                <router-link :to="'/'">Home</router-link>
            </li>
            <li class="breadcrumb-item">
                <span>Runners</span>
            </li>
        </ul>
    </div>
    <div class="runners hr-tile greeble-tr">
      <RunnerListGrid></RunnerListGrid>
    </div>
  </div>
</div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-facing-decorator";
import RunnerListGrid from "@/components/User/RunnerListGrid.vue";

@Component({
  components: {
    RunnerListGrid
  }
})
export default class Runners extends Vue {
}

</script>